<template>
  <div
    ref="textListModal"
    aria-hidden="true"
    aria-labelledby="textListModal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div v-if="title" class="modal-header">
          <h5 class="modal-title textStyle">
            {{ title }}
          </h5>
          <button
            aria-label="Close"
            class="btn-close"
            data-bs-dismiss="modal"
            data-dismiss="modal"
            type="button"
          ></button>
        </div>
        <div class="modal-body">
          <div v-for="(item, index) in list" :key="index" class="card">
            <TextCellDataTableComponent :item="item" :actions="actions" @emitRowAction="emitRowAction" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import TextCellDataTableComponent from "@/components/data-table/cell/TextCellDataTableComponent.vue";

export default {
  name: "TextContentModalComponentModalComponent",
  components: { TextCellDataTableComponent },
  props: {
    list: {
      type: Array,
      required: false,
      default: () => [],
    },
    actions: {
      type: Array,
      required: false,
      default: () => [],
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
    opened: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  emits: ["emitRowAction"],
  watch: {
    opened() {
      const container = this.$refs.textListModal;
      const modal = new Modal(container);
      if (this.opened) {
        modal.show();
      } else {
        modal.hide();
        this.$emit("hidden");
      }
    },
  },
  mounted() {
    this.$refs.textListModal.addEventListener("hidden.bs.modal", this.hidden);
  },
  methods: {
    hidden() {
      this.$emit("hidden");
      const container = this.$refs.textListModal;
      container.removeEventListener("click", this.stop);
    },

    stop(e) {
      e.stopPropagation();
    },

    emitRowAction(payload) {
      this.$emit("emitRowAction", payload);
    },
  },
};
</script>

<style scoped lang="scss">
.modal {
  z-index: 1061;
}
.indicator__container {
  padding: 10px 10px 0 10px;
  font-size: 15px;
}

.card {
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0 0 40px 0 rgba(94, 92, 154, 0.06);
  border: 1px solid $m-color_3;
}

.card + .card {
  margin-top: 10px;
}
</style>
